import { Component, Input, OnInit } from '@angular/core';
import { LocaleService } from '../../service/locale.service';

@Component({
  selector: 'app-empty',
  templateUrl: './empty.component.html',
  styleUrls: ['./empty.component.scss'],
  host: { class: 'animate__animated animate__fadeIn', '[class.empty]': 'smallText' },
})
export class EmptyComponent implements OnInit {
  @Input() text: string = this.localeService.getValue('no_record');
  @Input() icon: string = 'assets/svg/data-empty.svg';
  @Input() smallText: boolean = false;

  @Input() title = "Oops... There's no content to display";
  @Input() message = 'Contextual content';

  constructor(private localeService: LocaleService) {}

  ngOnInit() {}
}
